import { useRouteLoaderData } from '@remix-run/react';

import { CmsVideoProps } from '~/types/Cms';
import { resolveRichEditorImageSrc } from '~/utils/images';

const CmsVideo = ({ data }: CmsVideoProps) => {
  const rootData = useRouteLoaderData<typeof import('~/root').loader>('root');
  const alignment = data.align || 'inherit';
  const videoSrc = `${rootData?.ENV.API_URL}/media/${data.video}`;
  const videoType = data.video ? data.video.split('.').pop() : '';
  const posterSrc = data.image ? resolveRichEditorImageSrc(rootData?.ENV.API_URL, data.image) : undefined;
  return (
    <div className="cms-video" style={{ textAlign: alignment }}>
      <video
        className="cms-video__player"
        width="100%"
        poster={posterSrc}
        controls={data.controls}
        autoPlay={data.autoplay}
        muted={data.autoplay}
        loop={data.loop}
      >
        <source src={videoSrc} type={`video/${videoType}`} />
      </video>
    </div>
  );
};

export default CmsVideo;
